import apiClient from './apiClient';
import { getApiOrigin } from '@/config/env';

// Health, readiness and connectivity checks.
// `ping` lives under /api/v1 (relative); healthz/readyz live at the origin root (absolute).

/** GET /api/v1/ping → { message: 'pong' } */
export const ping = () => apiClient.get('/ping');

/** GET /healthz → { status, uptime, version } */
export const getHealth = () => apiClient.get(`${getApiOrigin()}/healthz`);

/**
 * GET /readyz → { status, checks: { postgres, redis, storage } }.
 * Returns 503 when not ready; we accept that status so the check payload is still readable
 * (a real "not ready" state is data to display, not a request failure).
 */
export const getReadiness = () =>
  apiClient.get(`${getApiOrigin()}/readyz`, {
    validateStatus: (status) => status >= 200 && status < 600,
  });
